export type DocumentCreatorFields = {
    createdBy?: string;
    createdByName?: string;
    createdByEmail?: string;
};

export function resolveDocumentCreatorEmail(
    document: DocumentCreatorFields | null | undefined,
    fallbackEmail?: string,
): string {
    const creatorEmail = String(document?.createdByEmail || '').trim().toLowerCase();
    if (creatorEmail) {
        return creatorEmail;
    }

    return String(fallbackEmail || '').trim().toLowerCase();
}

export function buildDocumentCreatorFields(input: {
    userId?: string | null;
    userName?: string | null;
    userEmail?: string | null;
}): DocumentCreatorFields {
    const createdBy = String(input.userId || '').trim();
    const createdByName = String(input.userName || '').trim();
    const createdByEmail = String(input.userEmail || '').trim().toLowerCase();

    return {
        ...(createdBy ? { createdBy } : {}),
        ...(createdByName ? { createdByName } : {}),
        ...(createdByEmail ? { createdByEmail } : {}),
    };
}
